const PERSONALIZED_SUPPORT_PLAN_TAG = 'support_level_5_pers';

export { PERSONALIZED_SUPPORT_PLAN_TAG };
